// PARA-127, AC-7: кнопка бота открывает Mini App по прямому HTTPS-URL с меткой
// источника в query (`?source=bot`). start_param в initData при таком открытии
// не приходит, поэтому метку читает frontend и передаёт её в POST /auth/telegram.

// Предел длины метки на backend (TelegramAuthRequest). Заведомо непригодное
// значение не отправляем: метка вспомогательная и вход ломать не должна.
const MAX_SOURCE_LENGTH = 32;

export function readAcquisitionSource(): string | undefined {
  const source = new URLSearchParams(window.location.search).get('source');
  if (!source || source.length > MAX_SOURCE_LENGTH) {
    return undefined;
  }
  return source;
}
